export const parseRowGivenHeader = (headers) => (row) =>
  Object.fromEntries(
    row.split(/\s+/).map((value, index) => [headers[index], value])
  );

const rowAsInterface = parseRowGivenHeader(["name", "id"]);

export const parseInterfacesList = (input) => {
  const [_head, ...lines] = input.trim().split("\n");
  return lines.map(rowAsInterface);
};

export const loadAndParseInterfaces = () =>
  ifCl.run("show interface pkteng interface-id").then(parseInterfacesList);

export default loadAndParseInterfaces;
